import React from "react";

import { HeaderNSidebar } from "components/template/HeaderNSidebar";
import { ProductBatch } from "components/template/Product";

import "./CSVPage.scss";

export const CSVPage: React.FC = () => {
  return (
    <HeaderNSidebar cx={"CSVPage"}>
      <div className="csv-page-wrapper">
        <ProductBatch />
      </div>
    </HeaderNSidebar>
  );
};
